async function getBestSeller(){
    const query = `
        query BestSelling{
            products(first:10, sortKey:BEST_SELLING){
                edges{
                    node{
                        handle
                        id
                        title
                        collections(first:10){
                            edges{
                                node{
                                    handle
                                    title
                                    onlineStoreUrl
                                }
                            }
                        }
                    }
                }
            }
        }
    `;
    const response = await executeQuery(query, {});
    if (!response.data) return;
    return response;
}